import {useEffect, useRef, useState} from "react";
import {mrbgStore} from "./mrbg/mrbgRedux";

function Slider({mainStyle}){

  const
    sliderUl = useRef(),
    [slides] = useState(mrbgStore.getState().mrbgVars.slider),
    [prlCls,setPrlCls] = useState(' '+mainStyle.PRL_slider),
    [activeSlide,setActiveSlide] = useState(0),  // SHOWN SLIDE
    [top,setTop] = useState( 0);

  useEffect(()=>{},[top])
  useEffect(() => {
    if (slides.length > 1) {
      const interval = setInterval(() => {
        setActiveSlide((prev) => (prev + 1) % slides.length);
      }, 7000);
      return () => clearInterval(interval);
    }
  }, [slides.length]);
  useEffect(()=>{
    setPrlCls('');
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const newTop = -1 * Math.min(document.documentElement.scrollTop / 2, window.innerHeight);
          setTop(newTop);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  },[])

  return(
    <section id={mainStyle.sliderFrame} style={{top}}>
      <ul id={mainStyle.sliderList} ref={sliderUl}>
        {
          slides.map((sld,k)=>{
            return(
              <li className={`${mainStyle.sliderItem}${prlCls}${k==activeSlide? ' '+mainStyle.activeSlide: ''}`} key={k}>
                <div className={mainStyle.sliderText}>
                  <div>
                    <h2>{sld.title}</h2>
                    <div>{sld.subtitle}</div>
                    <a href={sld.link} className={mainStyle.contentBtn}>{sld.btnText}</a>
                  </div>
                </div>
                <figure className={mainStyle.sliderImg}>
                  <img src={`/img/${sld.img}`} alt={sld.alt}/>
                </figure>
              </li>
            )
          })
        }
      </ul>
    </section>
  )
}

export default Slider;